import(/* webpackMode: "eager" */ "/codebuild/output/src967172558/src/nextjs-grudder/src/app/auth/error.tsx");
